<template>
  <div id="app">
    <pdf-preview :pdfURL="pdfURL"/>
    <!-- <router-view /> -->
  </div>
</template>

<script>
import pdfPreview from './components/pdf-preview.vue'
export default {
  name: 'App',
  components: { pdfPreview },
  data() { 
    return {
      pdfURL: 'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf',
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue